<script>
export default {
  name: 'VestidasIcon',
  props: {
    size: {
      type: [Number, String],
      default: 40,
    },
    color: {
      type: String,
      default: '#231F20',
    },
    colorInternal: {
      type: String,
      default: '#4339F2',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando a máscara nas instâncias duplicadas.
    maskId() {
      return `mask0_7703_391446_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6667 11.6667C11.6667 10.745 12.4133 10 13.3333 10C14.2533 10 15 10.745 15 11.6667C15 12.5883 14.2533 13.3333 13.3333 13.3333C12.4133 13.3333 11.6667 12.5883 11.6667 11.6667ZM18.3333 11.6667C18.3333 10.745 19.08 10 20 10C20.92 10 21.6667 10.745 21.6667 11.6667C21.6667 12.5883 20.92 13.3333 20 13.3333C19.08 13.3333 18.3333 12.5883 18.3333 11.6667ZM8.33333 15V10C8.33333 9.08 9.08167 8.33333 10 8.33333H30C30.9183 8.33333 31.6667 9.08 31.6667 10V15H8.33333ZM31.6667 30C31.6667 30.92 30.9183 31.6667 30 31.6667H10C9.08167 31.6667 8.33333 30.92 8.33333 30V18.3333H31.6667V30ZM30 5H10C7.24333 5 5 7.24333 5 10V15V18.3333V30C5 32.7567 7.24333 35 10 35H30C32.7567 35 35 32.7567 35 30V18.3333V15V10C35 7.24333 32.7567 5 30 5Z"
      :fill="color"
    />
    <mask
      :id="maskId"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="5"
      y="5"
      width="30"
      height="30"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6667 11.6667C11.6667 10.745 12.4133 10 13.3333 10C14.2533 10 15 10.745 15 11.6667C15 12.5883 14.2533 13.3333 13.3333 13.3333C12.4133 13.3333 11.6667 12.5883 11.6667 11.6667ZM18.3333 11.6667C18.3333 10.745 19.08 10 20 10C20.92 10 21.6667 10.745 21.6667 11.6667C21.6667 12.5883 20.92 13.3333 20 13.3333C19.08 13.3333 18.3333 12.5883 18.3333 11.6667ZM8.33333 15V10C8.33333 9.08 9.08167 8.33333 10 8.33333H30C30.9183 8.33333 31.6667 9.08 31.6667 10V15H8.33333ZM31.6667 30C31.6667 30.92 30.9183 31.6667 30 31.6667H10C9.08167 31.6667 8.33333 30.92 8.33333 30V18.3333H31.6667V30ZM30 5H10C7.24333 5 5 7.24333 5 10V15V18.3333V30C5 32.7567 7.24333 35 10 35H30C32.7567 35 35 32.7567 35 30V18.3333V15V10C35 7.24333 32.7567 5 30 5Z"
        fill="white"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <rect :width="size" :height="size" :fill="color" />
    </g>
  </svg>
</template>
